export const BRAND_NAME = "QC Home and Business Project Pro's";

type BrandLogoVariant = "horizontal" | "shield";

// Crest lockups per the Brand & Style Guide (Aug 2026): compact (B) for wide
// spaces, badge (C) for placements below 120px wide. The legacy variant names
// are kept so call sites stay stable.
export function BrandLogo({
  variant = "horizontal",
  className = "",
}: {
  variant?: BrandLogoVariant;
  className?: string;
}) {
  const compact = variant === "shield";

  return (
    <img
      src={compact ? "/brand/qc-crest-badge-ink.png" : "/brand/qc-crest-compact-ink.png"}
      alt={BRAND_NAME}
      width={compact ? 102 : 200}
      height={compact ? 32 : 69}
      className={`${compact ? "h-8 w-auto" : "h-auto w-[200px] min-w-[120px]"} ${className}`.trim()}
      draggable={false}
    />
  );
}
